<div class="container">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <div>
    <div class="title">
      <h2 *ngIf="!queryParams.id">Novo Usuário</h2>
      <h2 *ngIf="queryParams.id">Edição de Usuário</h2>
    </div>
  </div>

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <h3 *ngIf="!queryParams.id">Cadastrar</h3>
      <h3 *ngIf="queryParams.id">Editar</h3>
    </mat-expansion-panel-header>

    <form [formGroup]="userForm" (submit)="onSubmit()">
      <div
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between stretch"
      >
        <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>Tipo</mat-label>
          <mat-select id="type" name="type" formControlName="type">
            <mat-option
              *ngFor="let userType of optionsUserType"
              [value]="userType.value"
            >
              {{ userType.viewValue }}
            </mat-option>
          </mat-select>
          <mat-hint
            *ngIf="!userForm.get('type').valid && userForm.get('type').touched"
            class="error__input"
          >
            {{ userForm.get("type").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100"> -->
        <div fxLayout="column" fxFlex="50">
          <mat-label>Status</mat-label>
          <mat-slide-toggle
            formControlName="active"
            color="primary"
            (change)="changeStatus()"
          >
            {{
              userForm.get("active").value ? "Ativo" : "Inativo"
            }}</mat-slide-toggle
          >
        </div>

        <!-- </mat-form-field> -->
      </div>

      <div fxLayout="row">
        <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="auto">
          <mat-label>Nome</mat-label>
          <input matInput id="name" name="name" formControlName="name" />
          <mat-hint
            *ngIf="!userForm.get('name').valid && userForm.get('name').touched"
            class="error__input"
          >
            {{ userForm.get("name").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="auto">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            type="email"
            id="email"
            name="email"
            formControlName="email"
          />
          <mat-hint
            *ngIf="
              !userForm.get('email').valid && userForm.get('email').touched
            "
            class="error__input"
          >
            {{ userForm.get("email").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>
      </div>

      <div fxLayout="row">
        <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="auto">
          <mat-label>Função</mat-label>
          <input
            matInput
            id="function"
            name="function"
            formControlName="function"
          />
          <mat-hint
            *ngIf="
              !userForm.get('function').valid &&
              userForm.get('function').touched
            "
            class="error__input"
          >
            {{ userForm.get("function").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="auto">
          <mat-label>Telefone</mat-label>
          <input
            matInput
            type="phone"
            id="phone"
            name="phone"
            formControlName="phone"
          />
          <mat-hint
            *ngIf="
              !userForm.get('phone').valid && userForm.get('phone').touched
            "
            class="error__input"
          >
            {{ userForm.get("phone").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>
      </div>

      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutAlign.lt-md="start center"
        class="title__sub-title"
      >
        <mat-icon class="icons__info">vpn_key</mat-icon>
        <div>Informações de acesso ao sistema</div>
      </div>

      <div fxLayout="row" fxLayout.lt-md="column">
        <mat-form-field appearance="outline" fxFlex="40" fxFlex.lt-md="100">
          <mat-label>Usuário</mat-label>
          <input
            matInput
            id="username"
            name="username"
            formControlName="username"
            [readonly]="queryParams.id"
          />
          <mat-hint
            *ngIf="
              !userForm.get('username').valid &&
              userForm.get('username').touched
            "
            class="error__input"
          >
            {{ userForm.get("username").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          fxFlex="30"
          fxFlex.lt-md="100"
          *ngIf="!this.queryParams.id"
        >
          <mat-label>Senha</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            id="password"
            name="password"
            formControlName="password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'hidePassword password'"
            [attr.aria-pressed]="hidePassword"
          >
            <mat-icon>{{
              hidePassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
          <mat-hint
            *ngIf="
              !userForm.get('password').valid &&
              userForm.get('password').touched
            "
            class="error__input"
          >
            {{ userForm.get("password").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          fxFlex="30"
          fxFlex.lt-md="100"
          *ngIf="!this.queryParams.id"
        >
          <mat-label>Confirmação de Senha</mat-label>
          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            id="password"
            id="confirmPassword"
            name="confirmPassword"
            formControlName="confirmPassword"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="'hideConfirmPassword password'"
            [attr.aria-pressed]="hideConfirmPassword"
          >
            <mat-icon>{{
              hideConfirmPassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
          <mat-hint
            *ngIf="
              !userForm.get('confirmPassword').valid &&
              userForm.get('confirmPassword').touched
            "
            class="error__input"
          >
            {{ userForm.get("confirmPassword").errors | errorMessageFG }}
          </mat-hint>
        </mat-form-field>
      </div>

      <div
        fxLayout="column"
        *ngIf="
          !userForm.get('type').errors && userForm.get('type').value !== 'A'
        "
      >
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutAlign.lt-md="start center"
          class="title__sub-title"
        >
          <mat-icon class="icons__info">business</mat-icon>
          <div>Associação de Locais</div>
        </div>

        <div>
          <h2>Clientes</h2>
          <div cdkDropListGroup fxLayout="row" fxLayout.lt-md="column">
            <div class="dragdrop-container" fxFlex="50" fxFlex.lt-md="auto">
              <h3>Disponíveis ({{ companiesAvailable.length }})</h3>

              <div
                cdkDropList
                [(cdkDropListData)]="companiesAvailable"
                class="dragdrop-list"
                (cdkDropListDropped)="dropCompany($event)"
              >
                <div
                  class="dragdrop-box"
                  [cdkDragDisabled]="
                    userForm.get('type').value === 'C' &&
                    companiesAssociate.length > 0
                  "
                  *ngFor="let company of companiesAvailable"
                  cdkDrag
                >
                  {{ company.description }}
                </div>
              </div>
            </div>

            <div fxLayoutAlign="center center" fxFlex="5" class="arrows">
              <div fxLayout="column" fxLayoutAlign="space-between center">
                <mat-icon
                  class="icons"
                  matTooltip="Associar Todos"
                  matTooltipPosition="above"
                  (click)="associateAllCompany()"
                  >keyboard_arrow_right
                </mat-icon>
                <br />
                <mat-icon
                  class="icons"
                  matTooltip="Desassociar Todos"
                  matTooltipPosition="below"
                  (click)="desassociateAllCompany()"
                  >keyboard_arrow_left
                </mat-icon>
              </div>
            </div>

            <div class="dragdrop-container" fxFlex="50" fxFlex.lt-md="auto">
              <h3>Associadas ({{ companiesAssociate.length }})</h3>

              <div
                cdkDropList
                [cdkDropListData]="companiesAssociate"
                class="dragdrop-list"
                (cdkDropListDropped)="dropCompany($event)"
              >
                <div
                  class="dragdrop-box"
                  *ngFor="let company of companiesAssociate"
                  cdkDrag
                >
                  {{ company.description }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="companiesAssociate.length > 0">
          <h2>Regionais</h2>
          <div cdkDropListGroup fxLayout="row" fxLayout.lt-md="column">
            <div class="dragdrop-container" fxFlex="50" fxFlex.lt-md="auto">
              <h3>Disponíveis ({{ regionalsAvailable.length }})</h3>

              <div
                cdkDropList
                [(cdkDropListData)]="regionalsAvailable"
                class="dragdrop-list"
                (cdkDropListDropped)="dropRegional($event)"
              >
                <div
                  class="dragdrop-box"
                  *ngFor="let regional of regionalsAvailable"
                  cdkDrag
                >
                  {{ regional.description }}
                </div>
              </div>
            </div>

            <div fxLayoutAlign="center center" fxFlex="5" class="arrows">
              <div fxLayout="column" fxLayoutAlign="space-between center">
                <mat-icon
                  class="icons"
                  matTooltip="Associar Todos"
                  matTooltipPosition="above"
                  (click)="associateAllRegional()"
                  >keyboard_arrow_right
                </mat-icon>
                <br />
                <mat-icon
                  class="icons"
                  matTooltip="Desassociar Todos"
                  matTooltipPosition="below"
                  (click)="desassociateAllRegional()"
                  >keyboard_arrow_left
                </mat-icon>
              </div>
            </div>

            <div class="dragdrop-container" fxFlex="50" fxFlex.lt-md="auto">
              <h3>Associadas ({{ regionalsAssociate.length }})</h3>

              <div
                cdkDropList
                [cdkDropListData]="regionalsAssociate"
                class="dragdrop-list"
                (cdkDropListDropped)="dropRegional($event)"
              >
                <div
                  class="dragdrop-box"
                  *ngFor="let regional of regionalsAssociate"
                  cdkDrag
                >
                  {{ regional.description }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="regionalsAssociate.length > 0">
          <h2>Locais</h2>
          <div cdkDropListGroup fxLayout="row" fxLayout.lt-md="column">
            <div class="dragdrop-container" fxFlex="50" fxFlex.lt-md="auto">
              <h3>Disponíveis ({{ serviceLocalsAvailable.length }})</h3>

              <div
                cdkDropList
                [(cdkDropListData)]="serviceLocalsAvailable"
                class="dragdrop-list"
                (cdkDropListDropped)="drop($event)"
              >
                <div
                  class="dragdrop-box"
                  *ngFor="let serviceLocal of serviceLocalsAvailable"
                  cdkDrag
                >
                  {{ serviceLocal.description }}
                </div>
              </div>
            </div>

            <div fxLayoutAlign="center center" fxFlex="5" class="arrows">
              <div fxLayout="column" fxLayoutAlign="space-between center">
                <mat-icon
                  class="icons"
                  matTooltip="Associar Todos"
                  matTooltipPosition="above"
                  (click)="associateAllLocals()"
                  >keyboard_arrow_right
                </mat-icon>
                <br />
                <mat-icon
                  class="icons"
                  matTooltip="Desassociar Todos"
                  matTooltipPosition="below"
                  (click)="desassociateAllLocals()"
                  >keyboard_arrow_left
                </mat-icon>
              </div>
            </div>

            <div class="dragdrop-container" fxFlex="50" fxFlex.lt-md="auto">
              <h3>Associadas ({{ serviceLocalsAssociate.length }})</h3>

              <div
                cdkDropList
                [cdkDropListData]="serviceLocalsAssociate"
                class="dragdrop-list"
                (cdkDropListDropped)="drop($event)"
              >
                <div
                  class="dragdrop-box"
                  *ngFor="let serviceLocal of serviceLocalsAssociate"
                  cdkDrag
                >
                  {{ serviceLocal.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="btn__footer__container"
        fxLayout="row"
        fxLayoutAlign="end center"
      >
        <button
          mat-raised-button
          type="submit"
          color="primary"
          class="btn__add"
          *ngIf="!queryParams.id"
        >
          Cadastrar
        </button>
        <button
          mat-raised-button
          type="submit"
          color="primary"
          class="btn__add"
          *ngIf="queryParams.id"
        >
          Alterar
        </button>
        <button
          mat-raised-button
          type="button"
          class="btn__delete"
          color="primary"
          *ngIf="queryParams.id"
          (click)="changePassword()"
          matTooltip="Alterar Senha de Acesso"
          matTooltipPosition="below"
        >
          <mat-icon class="btn__delete__icon">vpn_key</mat-icon>
        </button>
        <button
          mat-raised-button
          type="button"
          color="warn"
          class="btn__delete"
          *ngIf="queryParams.id"
          (click)="delete()"
          matTooltip="Excluir Usuário"
          matTooltipPosition="below"
        >
          <mat-icon class="btn__delete__icon">delete</mat-icon>
        </button>
      </div>
    </form>
  </mat-expansion-panel>
</div>
